import React from 'react';
import PropTypes from 'prop-types';

export function CoreTextarea({
	name, value, onBlur, onFocus, onChange
}) {
	return (
		<textarea
			name={name}
			value={value}
			onBlur={onBlur}
			onFocus={onFocus}
			onChange={onChange}
			className="ph-textarea"
		/>
	);
}

CoreTextarea.propTypes = {
	name: PropTypes.string,
	value: PropTypes.string,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onChange: PropTypes.func
};

export default CoreTextarea;
